export class Question {
    idPerfil?: number;
    idCompetencia!: number;
    titulo!: string;
    descripcion!: string;
    value!: number;

}
